import styled from 'styled-components';
import { ThemePrisma } from '@orbita-ui/brand';

export const BreadcrumbContainer = styled.div`
  padding: ${ThemePrisma.spacing.large} ${ThemePrisma.spacing.xsmall};
  box-sizing: border-box;
  width: 100%;

  @media screen and (min-width: 768px) {
    padding: ${ThemePrisma.spacing.large} ${ThemePrisma.spacing.small};
  }

  .bc-container {
    display: flex;
    gap: 4px;
    -webkit-box-align: center;
    align-items: center;

    svg {
      width: 16px;
      height: 16px;
      color: ${ThemePrisma.colors.gray[5]};

      &.main {
        color: ${ThemePrisma.colors.gray[7]};
      }
    }

    p {
      font-family: Inter, sans-serif;
      font-size: 0.875rem;
      letter-spacing: 0em;
      line-height: 1.5rem;
      font-weight: 400;
      color: ${ThemePrisma.colors.gray[6]};

      &.last {
        color: ${ThemePrisma.colors.gray[7]};
        font-weight: 600 !important;
      }
    }
  }
`;
